import { postRequest, getRequest } from '../utils/axios';

import { trackEvent, getCookie } from '../utils/tracking';
import { authService } from './auth';


export const paymentService = {
    initiateCheckout,
    modifyPlan,
    downgradeToFreeTrial,
    getPaymentPortalUrl,
    activateDaypass,
    updateLimitPack,
    initiateLtdConvertCheckout,
    paywallViewed,
    deleteAccount,
    downloadAccountData,
};

function initiateCheckout(data, onSuccess, onError) {

  // fire analytics event upon starting a checkout
  trackEvent("InitiateCheckout", data);

  // gather datafast identifiers and add to metadata
  let metadata = {};
  if (getCookie('datafast_visitor_id')) {
    metadata['datafast_visitor_id'] = getCookie('datafast_visitor_id');
    metadata['datafast_session_id'] = getCookie('datafast_session_id');
  }

  return postRequest(
    `/api/v1/payments/checkout/`,
    Object.assign({
      'metadata': metadata, // adds datafast identifiers and send rest of checkout data
    }, data),
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function modifyPlan(data, onSuccess, onError) {
  return postRequest(
    `/api/v1/payments/modify/`,
    data,
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function downgradeToFreeTrial(data, onSuccess, onError) {
  return postRequest(
    `/api/v1/payments/downgrade/`,
    data,
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function getPaymentPortalUrl(data, onSuccess, onError) {
  return postRequest(
    `/api/v1/payments/payment-portal-url/`, data,
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function activateDaypass(onSuccess, onError) {
  return postRequest(
    `/api/v1/payments/activate-pass/`, {},
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

// add/update/delete limit packs
function updateLimitPack(data, onSuccess, onError) {
  return postRequest(
    `/api/v1/payments/update-limit/`,
    data,
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function initiateLtdConvertCheckout(data, onSuccess, onError) {

  // fire analytics event upon starting a checkout
  // trackEvent("InitiateCheckout", data);

  return postRequest(
    `/api/v1/payments/checkout-ltd-convert/`,
    data,
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function paywallViewed(data, onSuccess, onError) {
  return postRequest(
    `/api/v1/payments/paywall-view/`,
    data,
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function deleteAccount(onSuccess, onError) {
  return postRequest(
    `/api/v1/delete-account/`,
    {},
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}

function downloadAccountData(data, onSuccess, onError) {
  return postRequest(
    `/api/v1/download-account-data/`,
    data,
    (response) => {
      if (onSuccess){
        return onSuccess(response)
      }
    },
    (error, response) => {
      if (onError){
        return onError(error, response)
      }
    }
  )
}